// @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faShieldHalved, faBuilding } from "@fortawesome/free-solid-svg-icons";
import { sendApiRequest } from "../utils";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "./Loader";
import { useDispatch } from "react-redux";
import { setValue } from '../features/UserInfo/userSlice';
import loginBg from '../assets/images/loginbg.jpg';
import logo from '../assets/images/logo.png';
import Swal from 'sweetalert2';
import { motion } from "framer-motion";

const Login = ({ setIsRefresh }) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onSubmit = async (data) => {
        try {
            const payload = { loginId: data.username, password: data.password };
            const response = await sendApiRequest('api/auth/login', payload, "POST");

            if (response.data.success) {
                localStorage.setItem('auth_token', response.data.token);
                dispatch(setValue(response.data.user));
                setIsRefresh("Rescheck");

                Swal.fire({
                    title: 'Login Successful!',
                    html: `Welcome back, ${response.data.user.fullName}!`,
                    icon: 'success',
                    confirmButtonText: 'Continue',
                    confirmButtonColor: '#2AADCC',
                    background: '#ffffff'
                })

                if (response.data.user.email === 'prayagproperties2020@gmail.com') {
                    navigate('/admin')
                } else {
                    navigate('/dashboard')
                }
            } else {
                Swal.fire({
                    title: 'Login Failed',
                    text: response.data.message || 'Invalid credentials',
                    icon: 'error',
                    confirmButtonText: 'Try Again',
                    confirmButtonColor: '#2AADCC'
                });
            }
        } catch (error) {
            console.error("Login error:", error);
            Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Invalid credentials.',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#2AADCC'
            });
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-3 sm:p-5 md:p-10 relative overflow-hidden">
            {/* Background Image with fade-in animation */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(${loginBg})`,
                    opacity: '1',
                }}
            >
            </motion.div>

            {/* Animated Floating Glass Card */}
            <motion.div
                initial={{ y: 150, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                    type: "spring",
                    stiffness: 100,  // Increased from 70 (makes it "tighter")
                    damping: 15,     // Slightly reduced from 20 (less resistance)
                    mass: 0.5,       // Added - makes the object feel lighter
                    duration: 0.3    // Reduced from 0.5
                  }}
                className="relative bg-white/95 backdrop-blur-lg rounded-xl sm:rounded-2xl shadow-2xl p-4 sm:p-6 md:p-10 w-full max-w-md mx-2 sm:mx-4 overflow-hidden border border-[#2AADCC]/20 hover:shadow-3xl z-10"
            >
                {/* Decorative Elements */}
                <div className="absolute -top-16 sm:-top-20 -right-16 sm:-right-20 w-36 sm:w-48 h-36 sm:h-48 rounded-full bg-[#30AEB8]/20 blur-3xl -z-10"></div>
                <div className="absolute -bottom-16 sm:-bottom-20 -left-16 sm:-left-20 w-36 sm:w-48 h-36 sm:h-48 rounded-full bg-[#2AADCC]/20 blur-3xl -z-10"></div>

                {/* Company Branding */}
                <div className="flex flex-col items-center mb-4 sm:mb-6 md:mb-8">
                    <div className="mb-2 sm:mb-3 md:mb-4">
                        <img
                            src={logo}
                            alt="Prayag Properties Logo"
                            className="h-16 sm:h-20 md:h-28 w-auto object-contain"
                        />
                    </div>
                    <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-1">
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#262362] to-[#2AADCC]">
                            Prayag Properties & Mishra Constructions
                        </span>
                    </h1>
                </div>

                <form className="space-y-3 sm:space-y-4 md:space-y-5" onSubmit={handleSubmit(onSubmit)}>
                    {/* Username Field */}
                    <div className="group">
                        <label htmlFor="username" className="block text-xs sm:text-sm font-medium text-[#262362] mb-1 sm:mb-2 ml-1 transition-all duration-200 group-focus-within:text-[#2AADCC]">
                            Username or User ID
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-2 sm:pl-3 flex items-center pointer-events-none text-gray-400 group-focus-within:text-indigo-500 transition-colors">
                                <FontAwesomeIcon icon={faUser} className="text-sm sm:text-base" />
                            </div>
                            <input
                                id="username"
                                type="text"
                                placeholder="Enter username or ID"
                                className={`block w-full pl-8 sm:pl-10 pr-2 sm:pr-3 py-2 sm:py-3 rounded-lg sm:rounded-xl border-2 bg-white/80 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 transition-all duration-200 text-sm sm:text-base ${errors.username ? "border-rose-300 focus:ring-rose-200" : "border-gray-200 hover:border-indigo-200"
                                    }`}
                                {...register("username", {
                                    required: "Username or User ID is required",
                                    minLength: {
                                        value: 3,
                                        message: "Username must be at least 3 characters",
                                    },
                                })}
                            />
                        </div>
                        {errors.username && (
                            <p className="mt-1 sm:mt-1.5 text-xs sm:text-sm text-rose-600 animate-fade-in">{errors.username.message}</p>
                        )}
                    </div>

                    {/* Password Field */}
                    <div className="group">
                        <div className="flex items-center justify-between mb-1 sm:mb-2 ml-1">
                            <label htmlFor="password" className="block text-xs sm:text-sm font-medium text-[#262362] transition-all duration-200 group-focus-within:text-[#2AADCC]">
                                Password
                            </label>
                            <Link to="/forgot-password" className="text-xs sm:text-sm font-medium text-[#2AADCC] hover:text-[#30AEB8] hover:underline transition-colors">
                                Forgot Password?
                            </Link>
                        </div>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-2 sm:pl-3 flex items-center pointer-events-none text-gray-400 group-focus-within:text-indigo-500 transition-colors">
                                <FontAwesomeIcon icon={faLock} className="text-sm sm:text-base" />
                            </div>
                            <input
                                id="password"
                                type="password"
                                placeholder="Enter your password"
                                className={`block w-full pl-8 sm:pl-10 pr-2 sm:pr-3 py-2 sm:py-3 rounded-lg sm:rounded-xl border-2 bg-white/80 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 transition-all duration-200 text-sm sm:text-base ${errors.password ? "border-rose-300 focus:ring-rose-200" : "border-gray-200 hover:border-indigo-200"
                                    }`}
                                {...register("password", {
                                    required: "Password is required",
                                    minLength: {
                                        value: 8,
                                        message: "Password must be at least 8 characters",
                                    },
                                })}
                            />
                        </div>
                        {errors.password && (
                            <p className="mt-1 sm:mt-1.5 text-xs sm:text-sm text-rose-600 animate-fade-in">{errors.password.message}</p>
                        )}
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full flex justify-center items-center py-2.5 sm:py-3 md:py-3.5 px-3 sm:px-4 rounded-lg sm:rounded-xl shadow-lg text-white bg-gradient-to-r from-[#262362] to-[#2AADCC] hover:from-[#30AEB8] hover:to-[#33AEB5] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2AADCC]/30 transition-all duration-300 font-medium group overflow-hidden text-sm sm:text-base"
                    >
                        <span className="relative z-10 group-hover:scale-105 transition-transform">
                            {isSubmitting ? (
                                <Loader />
                            ) : (
                                "Login"
                            )}
                        </span>
                    </button>
                </form>

                {/* Footer Links */}
                <div className="mt-4 sm:mt-6 md:mt-8 pt-3 sm:pt-4 md:pt-5 border-t border-[#2AADCC]/10 text-center space-y-2 sm:space-y-3 md:space-y-4">
                    <p className="text-xs sm:text-sm text-[#262362]">
                        Are you a customer?{" "}
                        <Link
                            to="/login-customer"
                            className="font-medium text-[#2AADCC] hover:text-[#30AEB8] hover:underline transition-colors"
                        >
                            Login here
                        </Link>
                    </p>
                    <p className="text-xs sm:text-sm text-[#262362]">
                        Don't have an account?{" "}
                        <Link
                            to="/register"
                            className="font-medium text-[#2AADCC] hover:text-[#30AEB8] hover:underline transition-colors"
                        >
                            Create now
                        </Link>
                    </p>
                    <p className="text-[10px] sm:text-xs text-[#262362]/60 mt-2 sm:mt-3">
                        © {new Date().getFullYear()} Prayag Properties & Mishra Constructions. All rights reserved.
                    </p>
                </div>
            </motion.div>
        </div>
    );
};

export default Login;